import { render, staticRenderFns } from "./GalleryFormComponent.vue?vue&type=template&id=20f9f96a&scoped=true&"
import script from "./GalleryFormComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./GalleryFormComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GalleryFormComponent.vue?vue&type=style&index=1&id=20f9f96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9f96a",
  null
  
)

export default component.exports